module.exports = __webpack_public_path__ + "static/media/lidcore-sketch-1.2b0fc182.jpg";